var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManifests(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic_menu_manifest_32p",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_9",
    "data-name": "Mask Group 9",
    transform: "translate(-873 -1054)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_442",
    "data-name": "Group 442",
    transform: "translate(877.48 1054.96)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_441",
    "data-name": "Group 441",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3555",
    "data-name": "Path 3555",
    d: "M22.9,5.922,17.124.144A.492.492,0,0,0,16.776,0H1.543A1.545,1.545,0,0,0,0,1.543V28.857A1.545,1.545,0,0,0,1.543,30.4H21.5a1.545,1.545,0,0,0,1.543-1.543V6.27a.492.492,0,0,0-.144-.348M17.268,1.681l4.1,4.1H17.827a.559.559,0,0,1-.558-.558ZM21.5,29.415H1.543a.559.559,0,0,1-.558-.558V1.543A.559.559,0,0,1,1.543.985h14.74V5.22a1.545,1.545,0,0,0,1.543,1.543h4.235V28.857a.559.559,0,0,1-.558.558"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3556",
    "data-name": "Path 3556",
    d: "M11.917,42.679H10.867A1.019,1.019,0,0,0,9.849,43.7v1.05a1.019,1.019,0,0,0,1.018,1.018h1.051a1.019,1.019,0,0,0,1.018-1.018V43.7a1.019,1.019,0,0,0-1.018-1.018m.033,2.068a.033.033,0,0,1-.033.033H10.867a.033.033,0,0,1-.033-.033V43.7a.033.033,0,0,1,.033-.033h1.051a.033.033,0,0,1,.033.033Z",
    transform: "translate(-6.697 -29.022)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3557",
    "data-name": "Path 3557",
    d: "M23.472,43.663H28.2a.492.492,0,1,0,0-.985H23.472a.492.492,0,1,0,0,.985",
    transform: "translate(-15.626 -29.021)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3558",
    "data-name": "Path 3558",
    d: "M23.472,50.229H30.3a.492.492,0,0,0,0-.985H23.472a.492.492,0,0,0,0,.985",
    transform: "translate(-15.626 -33.486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3559",
    "data-name": "Path 3559",
    d: "M11.917,27.905H10.867a1.019,1.019,0,0,0-1.018,1.018v1.051a1.019,1.019,0,0,0,1.018,1.018h1.051a1.019,1.019,0,0,0,1.018-1.018V28.923a1.019,1.019,0,0,0-1.018-1.018m.033,2.068a.033.033,0,0,1-.033.033H10.867a.033.033,0,0,1-.033-.033V28.923a.033.033,0,0,1,.033-.033h1.051a.033.033,0,0,1,.033.033Z",
    transform: "translate(-6.697 -18.975)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3560",
    "data-name": "Path 3560",
    d: "M23.472,28.89H30.3a.492.492,0,0,0,0-.985H23.472a.492.492,0,1,0,0,.985",
    transform: "translate(-15.626 -18.975)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3561",
    "data-name": "Path 3561",
    d: "M35.029,34.471H23.473a.492.492,0,0,0,0,.985H35.029a.492.492,0,1,0,0-.985",
    transform: "translate(-15.627 -23.44)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3562",
    "data-name": "Path 3562",
    d: "M11.917,13.132H10.867A1.019,1.019,0,0,0,9.849,14.15V15.2a1.019,1.019,0,0,0,1.018,1.018h1.051A1.019,1.019,0,0,0,12.935,15.2V14.15a1.019,1.019,0,0,0-1.018-1.018M11.95,15.2a.033.033,0,0,1-.033.033H10.867a.033.033,0,0,1-.033-.033V14.15a.033.033,0,0,1,.033-.033h1.051a.033.033,0,0,1,.033.033Z",
    transform: "translate(-6.697 -8.93)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3563",
    "data-name": "Path 3563",
    d: "M23.472,14.117H28.2a.492.492,0,1,0,0-.985H23.472a.492.492,0,1,0,0,.985",
    transform: "translate(-15.626 -8.93)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3564",
    "data-name": "Path 3564",
    d: "M23.472,20.682H30.3a.492.492,0,0,0,0-.985H23.472a.492.492,0,1,0,0,.985",
    transform: "translate(-15.626 -13.394)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3565",
    "data-name": "Path 3565",
    d: "M11.917,57.452H10.867A1.019,1.019,0,0,0,9.849,58.47V59.52a1.019,1.019,0,0,0,1.018,1.018h1.051a1.019,1.019,0,0,0,1.018-1.018V58.47a1.019,1.019,0,0,0-1.018-1.018m.033,2.068a.033.033,0,0,1-.033.033H10.867a.033.033,0,0,1-.033-.033V58.47a.033.033,0,0,1,.033-.033h1.051a.033.033,0,0,1,.033.033Z",
    transform: "translate(-6.697 -39.067)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3566",
    "data-name": "Path 3566",
    d: "M23.472,58.436H30.3a.492.492,0,0,0,0-.985H23.472a.492.492,0,1,0,0,.985",
    transform: "translate(-15.626 -39.067)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3567",
    "data-name": "Path 3567",
    d: "M35.029,64.017H23.473a.492.492,0,0,0,0,.985H35.029a.492.492,0,1,0,0-.985",
    transform: "translate(-15.627 -43.532)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManifests);
export default __webpack_public_path__ + "static/media/Manifests.85e5b85a22fb8789a21691cf72a0b606.svg";
export { ForwardRef as ReactComponent };